// Contenu centralisé du site — modifiez ici textes, coordonnées, formules et projets.

export const brand = {
  name: "SANAA DESIGN STUDIO",
  signature: "Le design au service de votre visibilité.",
  city: "Toulouse",
  area: "France",
};

export const contact = {
  email: "contact@sanaadesignstudio.fr",
  phone: "06 65 31 11 73",
  phoneIntl: "+33665311173",
  instagram: { handle: "@sanaadesignstudio", url: "https://www.instagram.com/sanaadesignstudio/" },
};

export const primaryCta = { label: "Demander un diagnostic digital", to: "/diagnostic" };

export const nav = [
  { label: "Studio", to: "/studio" },
  { label: "Expertises", to: "/expertises" },
  { label: "Réalisations", to: "/realisations" },
  { label: "Tarifs", to: "/tarifs" },
  { label: "Secteurs", to: "/secteurs" },
  { label: "Référencement local", to: "/referencement-local-toulouse" },
  { label: "Contact", to: "/contact" },
];

export const marquee = ["Sites sur mesure", "Réservation en ligne", "Google Business Profile", "Référencement local", "Direction artistique"];

export const constat = [
  { n: "01", title: "Être trouvé", text: "Apparaître sur Google quand on cherche un commerce comme le vôtre, près de chez soi." },
  { n: "02", title: "Rassurer", text: "Une image soignée et des infos claires : carte, tarifs, horaires, accès." },
  { n: "03", title: "Faire passer à l'action", text: "Appeler, réserver ou demander un devis en un geste depuis le téléphone." },
];

export const services = [
  {
    n: "01", id: "creation-site", title: "Création de sites internet",
    text: "Des sites vitrines sur mesure, rapides et pensés pour le mobile : carte, prestations, galerie, formulaire, réservation.",
    cta: "Découvrir le service", to: "/expertises/creation-site-internet",
  },
  {
    n: "02", id: "seo-local", title: "Référencement local",
    text: "Je structure vos pages et vos contenus pour que Google comprenne ce que vous faites, et où.",
    cta: "Améliorer ma visibilité", to: "/referencement-local-toulouse",
  },
  {
    n: "03", id: "presence-google", title: "Présence Google",
    text: "J'optimise votre fiche Google Business Profile : catégories, description, photos, horaires, liens.",
    cta: "Optimiser ma fiche Google", to: "/referencement-local-toulouse#google-business-profile",
  },
  {
    n: "04", id: "strategie-conversion", title: "Réservation et conversion",
    text: "Appel en un clic, prise de rendez-vous ou de table, arrhes, agenda : moins de friction, plus de demandes.",
    cta: "Développer mon activité", to: "/tarifs",
  },
];

export const plans = [
  { id: "essentiel", name: "Essentiel", price: "990 €", unit: "", desc: "Site vitrine de 1 à 5 pages.", items: ["Design sur mesure", "Adapté au mobile", "Appel et formulaire de contact", "Bases du référencement local"] },
  { id: "reservation", name: "Réservation", price: "1 890 €", unit: "", desc: "Site + prise de rendez-vous ou de table en ligne.", items: ["Tout l'Essentiel", "Réservation en ligne", "Arrhes", "Agenda"], featured: true },
  { id: "visibilite", name: "Visibilité locale", price: "390 €", unit: "", desc: "Fiche Google + référencement local.", items: ["Optimisation Google Business Profile", "Mots-clés locaux", "Titres et métadonnées", "Cohérence des coordonnées"] },
  { id: "suivi", name: "Hébergement et suivi", price: "39 €", unit: "/mois", desc: "Votre site hébergé et suivi.", items: ["Hébergement", "Mises à jour", "Suivi du site"] },
];

export const pricingNote = "Tarifs indicatifs — devis personnalisé gratuit";

export const sectors = [
  {
    id: "restaurants", title: "Restaurants & cafés", who: "Restaurants, bistrots, brasseries, cafés",
    pitch: "Votre carte lisible sur mobile, l'appel en un clic, les horaires et l'itinéraire. Le reste, c'est votre cuisine.",
    stakes: ["Carte et menus à jour", "Bouton « Appeler pour réserver »", "Horaires et accès en un geste", "Réservation en ligne si besoin"],
    project: "oh-la-vache",
  },
  {
    id: "beaute", title: "Beauté & bien-être", who: "Instituts, spas, esthéticiennes, coiffeurs, barbiers",
    pitch: "Vos soins, vos tarifs, votre univers. Et une réservation en ligne avec arrhes pour limiter les rendez-vous non honorés.",
    stakes: ["Carte des soins et tarifs clairs", "Réservation et arrhes en ligne", "Cartes cadeaux", "Site bilingue si votre clientèle l'est"],
    project: "maison-sanaa",
  },
  {
    id: "commerces", title: "Commerces & boutiques", who: "Boutiques, concept stores, commerces indépendants",
    pitch: "Donner envie de pousser la porte : votre sélection, vos horaires, votre adresse, cohérents avec votre fiche Google.",
    stakes: ["Présentation de l'offre", "Infos pratiques à jour", "Lien avec la fiche Google", "Liens vers vos réseaux"],
  },
  {
    id: "artisans", title: "Artisans & indépendants", who: "Artisans, indépendants, petites entreprises",
    pitch: "Vos prestations, votre zone d'intervention et vos réalisations. Une demande de devis simple et complète.",
    stakes: ["Prestations et zone claires", "Galerie de réalisations", "Formulaire de devis", "Visibilité sur les recherches locales"],
  },
];

export const steps = [
  { n: "01", title: "Découverte", text: "Votre activité, vos clients, vos objectifs." },
  { n: "02", title: "Analyse", text: "Votre présence actuelle et ce qui peut progresser." },
  { n: "03", title: "Création", text: "Le design, les textes, la réservation." },
  { n: "04", title: "Mise en ligne", text: "Publication et optimisations convenues." },
  { n: "05", title: "Évolution", text: "Mesure et pistes d'amélioration." },
];

export const reasons = [
  "Un seul interlocuteur : moi, du premier échange à la mise en ligne.",
  "Une image soignée, à la hauteur de votre établissement.",
  "Des textes courts et clairs, écrits pour vos clients.",
  "Un site pensé d'abord pour le téléphone.",
  "La réservation et l'appel placés au bon endroit.",
  "Des indicateurs simples pour suivre les résultats.",
];

export const projects = [
  {
    slug: "maison-sanaa", name: "Maison Sanaa", place: "Soins visage et corps, haut de gamme", category: "Beauté & bien-être",
    url: "https://maisonsanaa.fr", domain: "maisonsanaa.fr",
    context: "Une maison de soins haut de gamme avait besoin d'un site à la hauteur de son exigence. Direction artistique sobre, parcours bilingue et réservation en ligne avec arrhes : la cliente découvre, choisit et réserve sans quitter la page.",
    deliverables: ["Direction artistique", "Site bilingue FR/EN", "Réservation en ligne + arrhes", "Agenda", "Cartes cadeaux", "SEO local", "Identité visuelle", "Visuels produits (concept)"],
    palette: [{ name: "Noir", hex: "#0A0A0A" }, { name: "Brun nuit", hex: "#1D1916" }, { name: "Taupe", hex: "#A29588" }, { name: "Ivoire", hex: "#F3EEE6" }],
  },
  {
    slug: "oh-la-vache", name: "Oh la Vache !", place: "Restaurant français, cuisine conviviale", category: "Restauration",
    context: "Pour un restaurant, chaque seconde compte. Le site met la carte au premier plan et transforme la visite en appel en un seul geste, depuis le téléphone.",
    deliverables: ["Site vitrine", "Carte", "Appel en un clic", "Horaires et accès"],
    palette: [{ name: "Brun noir", hex: "#17110D" }, { name: "Brique", hex: "#B4472D" }, { name: "Ocre", hex: "#E2B56A" }, { name: "Crème", hex: "#F2E8D8" }],
  },
  {
    slug: "etoile-doran", name: "L'étoile d'Oran", place: "Restaurant algérien, cuisine familiale", category: "Restauration",
    context: "Une cuisine qui se raconte. Le site présente l'histoire de la maison, la carte et les avis clients, puis guide naturellement vers la réservation.",
    deliverables: ["Site vitrine", "Récit", "Carte", "Avis clients", "Réservation"],
    palette: [{ name: "Noir", hex: "#080808" }, { name: "Bronze", hex: "#8E7350" }, { name: "Or", hex: "#C9A24A" }, { name: "Blanc cassé", hex: "#F5F0E6" }],
  },
].map((p) => ({
  ...p,
  shots: {
    home: `/images/projets/${p.slug}-accueil.webp`,
    s1: `/images/projets/${p.slug}-section-1.webp`,
    s2: `/images/projets/${p.slug}-section-2.webp`,
    mobile: `/images/projets/${p.slug}-mobile.webp`,
  },
}));

export const faq = [
  { q: "Pourquoi avoir un site internet ?", a: "Parce qu'il vous appartient. Vous y présentez votre offre comme vous le souhaitez, Google peut le comprendre et le proposer, et vos clients y trouvent de quoi appeler ou réserver." },
  { q: "Instagram ou site professionnel ?", a: "Les deux. Instagram montre votre quotidien ; le site organise l'information et peut apparaître sur les recherches Google. Je relie l'un à l'autre." },
  { q: "Comment améliorer sa visibilité locale ?", a: "Une fiche Google complète, un site avec une page par service, des coordonnées identiques partout, de bonnes photos et des avis authentiques. Personne ne peut garantir une position, mais la cohérence aide." },
  { q: "À quoi sert Google Business Profile ?", a: "C'est votre fiche dans Google Maps : horaires, adresse, téléphone, photos, avis, lien vers le site. Souvent, c'est le premier contact avec vous." },
  { q: "Comment faciliter les réservations ?", a: "Un bouton d'appel visible sur mobile, une réservation en ligne sur chaque page, des arrhes pour limiter les absences, et un formulaire court." },
  { q: "Comment mesurer les résultats ?", a: "Google Search Console pour les recherches, les statistiques de votre fiche Google pour les appels et itinéraires, et le suivi des formulaires et réservations." },
];
